module.exports = __webpack_public_path__ + "img/Andrew-Stephen-Secretary-Treasurer-2022-french.3dd6ca43.jpg";